module.exports = "<meta http-equiv=\"Cache-Control\" content=\"no-cache, no-store, must-revalidate\">\n<meta http-equiv=\"Pragma\" content=\"no-cache\">\n<meta http-equiv=\"Expires\" content=\"0\">\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/usr/clienti.qmedical/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main